import { render, staticRenderFns } from "./_select-merchant.vue?vue&type=template&id=4e0590b2&"
import script from "./_select-merchant.vue?vue&type=script&lang=js&"
export * from "./_select-merchant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports